import { HTTP } from './http'

export const asistencias = {
  io (user) {
    return HTTP.post('asistencias/io', { user })
  },
  cargarImagen (file, user, zona, tipo) {
    console.log(file)
    const form = new FormData()

    form.append('file', file)
    form.append('user', user)
    form.append('zona', zona)
    form.append('tipo', tipo)

    return HTTP.post('asistencias/cargarImagen', form)
  },
  entrada (user, fecha, nombreImagen, timestamp) {
    return HTTP.post('asistencias/Entrada', { user, fecha, nombreImagen, timestamp })
  },
  salida (user, nombreImagen, idAsistencia) {
    return HTTP.post('asistencias/Salida', { user, nombreImagen, idAsistencia })
  }
}
